import { FC } from "react";
import {
  Typography,
  Button,
  Container,
  Box,
  Grid,
  useMediaQuery,
  Link,
} from "@material-ui/core";
import Supp from "../../assets/images/support1.png";
import NoiseBg from '../../assets/images/noise.png';
import { CtaStyle } from "../Styles/LandingStyles";
import { useTheme } from "@material-ui/core/styles";

const Cta: FC = () => {
  const classes = CtaStyle();
  const theme = useTheme();
  const isActive = useMediaQuery(theme.breakpoints.down("sm"));
  const isMed = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <>
      <Box data-aos="fade-up" data-aos-duration="1200" component="section">
        <Grid container spacing={0}>
          <Grid
            item
            md={12}
            sm={12}
            className={classes.root}
          >
            <Container fixed>
              <Box className={classes.ctawrapper}>
                <Box
                  className="first-part"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    flexDirection: "column",
                    width: isActive ? "90%" : "60%",
                  }}
                >
                  <Typography
                    variant="h1"
                    className="title1 aspekta-semiBold"
                  >
                    Get help from a 24/7{" "}
                    <Box className="aspekta-regular">global support team</Box>
                  </Typography>
                  <br />
                  <br />
                  <Box
                    className="btn-container"
                    textAlign={isMed ? "center" : "left"}
                    mb={5}
                  >
                    <Link
                      href="https://t.me/+tIwaCtq58KthMDQ8"
                      target="_blank"
                      rel="noopener"
                    >
                      <Button
                        variant="contained"
                        className="hero-blue-bg white"
                        size="large"
                      >
                        Explore Our Support Center
                      </Button>
                    </Link>
                  </Box>
                </Box>
                <Box
                  style={{
                    display: "flex",
                    justifyContent: isActive ? "center" : "flex-end",
                    alignItems: "center",
                    width: "40%",
                  }}
                >
                  <img
                    src={Supp}
                    style={{ width: isActive ? "300px" : "500px" }}
                    alt="Gains support"
                  />
                </Box>
              </Box>
            </Container>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default Cta;
